import React, { useState } from 'react'
import http from '../../../../http'
import { withList } from '../../../../context/List'
import { withReload } from '../../../../context/Reload'
import Confirm from '../../../../components/Confirm'

function UpdateSelected( props ) {
  const {
    client,
    value,
    withReload: { reload }
  } = props

  const {
    list,
    clear
  } = props.withList

  const [ isOpen, setIsOpen ] = useState( false )

  function toggle( e ) {
    setIsOpen( ! isOpen )
  }

  function action() {
    // value
    let set = { 'Tipo de pagina': value }

    if ( value === 'Fake' )
      set = { ...set, Estado: 'Verificado' }

    http( {
      url: `/api/dataSource/${ client }/datos/updateMany`,
      method: 'PUT',
      data: {
        match: { _id: { $in: [ ...list ] } },
        set
      }
    } )
      .then( response => {
        clear()
        reload()
      } )
  }

  return (
    <button
      className="btn accent"
      onClick={ toggle }
      disabled={ value === '' || list.size === 0 }
    >
      update selected records { list.size > 0 ? `(${ list.size })` : '' }

      { isOpen ?
        <Confirm
          icon="FiGitCommit"
          message="do you want to update all selected records?"
          buttons={ [
            {
              icon: 'FiCheck',
              label: 'yes',
              type: 'yes',
              action
            },
            {
              icon: 'FiX',
              label: 'no',
              type: 'no',
              action: () => { toggle() }
            }
          ] }
          close={ toggle }
        />
      : null }
    </button>
  )
}

export default withReload( withList( UpdateSelected ) )
